import { css } from "@vitality-ds/system";
export default css({
  paddingLeft: "$lg",
  '&[data-state="checked"]': {
    paddingLeft: "$sm"
  }
});